// extracted by mini-css-extract-plugin
export default {"past":"index_past_M4GHD","pastH":"index_pastH_vlwbv","passItem":"index_passItem_1egD8"};